import { render, staticRenderFns } from "./actMaleMain.vue?vue&type=template&id=1741708b&scoped=true"
import script from "./actMaleMain.vue?vue&type=script&lang=js"
export * from "./actMaleMain.vue?vue&type=script&lang=js"
import style0 from "./actMaleMain.vue?vue&type=style&index=0&id=1741708b&prod&lang=less&scoped=true"
import style1 from "./actMaleMain.vue?vue&type=style&index=1&id=1741708b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1741708b",
  null
  
)

export default component.exports